import { types } from '../types'

const initialState = {
  WaitingProfile: false,
  SuccessProfile: false,
  ErrorProfile: '',
  profile: {},
  onlineStatus: 'offline'

}

const profileReducer = (state = initialState, { type, action, error, status }) => {
  switch (type) {

    case types.GET_PROFILE_REQUEST: {
      return {
        ...state,
        waitingProfile: true,
        SuccessProfile: false,
        ErrorProfile: ''

      }
    }
    case types.GET_PROFILE_SUCCESS: {

      return {
        ...state,
        WaitingProfile: false,
        SuccessProfile: true,
        profile: action.data,
      }
    }
    case types.GET_PROFILE_ERROR: {
      return {
        ...state,
        WaitingProfile: false,
        ErrorProfile: 'error',

      }
    }
    case types.SET_ONLINE_STATUS: {
      return {
        ...state,
        onlineStatus: status

      }
    }
    case types.GET_PROFILE_RESET_PROPS: {

      return {
        ...state,
        WaitingProfile: false,
        SuccessProfile: false,
        ErrorProfile: '',
        profile: {},
      }
    }

    default:
      return state
  }
}

export default profileReducer;